/**
 * @generated SignedSource<<950eb281b9e4daa7470fafc2344924dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AllSkillsFilterInput = {
  isActive?: boolean | null | undefined;
  skillCode?: string | null | undefined;
  skillName?: string | null | undefined;
  skillType?: string | null | undefined;
  standardGradeIds?: ReadonlyArray<string> | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
  targetIds?: ReadonlyArray<string> | null | undefined;
};
export type AssignmentSkillFilterOptionsQuery$variables = {
  filter?: AllSkillsFilterInput | null | undefined;
  first?: number | null | undefined;
};
export type AssignmentSkillFilterOptionsQuery$data = {
  readonly allSkills: {
    readonly nodes: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type AssignmentSkillFilterOptionsQuery = {
  response: AssignmentSkillFilterOptionsQuery$data;
  variables: AssignmentSkillFilterOptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Literal",
        "name": "order",
        "value": [
          {
            "name": "ASC"
          }
        ]
      }
    ],
    "concreteType": "SkillNodeConnection",
    "kind": "LinkedField",
    "name": "allSkills",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SkillNode",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignmentSkillFilterOptionsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignmentSkillFilterOptionsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "186a10f0a3aec847b10191dc2780ced9",
    "id": null,
    "metadata": {},
    "name": "AssignmentSkillFilterOptionsQuery",
    "operationKind": "query",
    "text": "query AssignmentSkillFilterOptionsQuery(\n  $filter: AllSkillsFilterInput\n  $first: Int\n) {\n  allSkills(filter: $filter, first: $first, order: [{name: ASC}]) {\n    nodes {\n      id\n      name\n      code\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "247aeba6833221ede15a7df3e3e5e768";

export default node;
